import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NotificationService } from '@progress/kendo-angular-notification';
import { Align } from '@progress/kendo-angular-popup';
import { SVGIcon, searchIcon } from '@progress/kendo-svg-icons';
import { SubmitCaseAssignModel } from 'src/app/modules/dashboard/models/submit-case-assign-model';
import { DashboardService } from 'src/app/modules/dashboard/services/dashboard.service';
import {
  dialogAnimationDuration,
  dialogTimer,
} from '../../constants/dialog-specs';
import { AbstractComponent } from '../abstract-component';
import { StaffSearchComponent } from '../staff-search/staff-search.component';
import { StudentDetails } from 'src/app/modules/student-search/models/student-details-model';
import { ApiResponse } from '../../interfaces/api-response';
import { CaseAssignment } from '../../interfaces/case-management';
import { NOTIFICATION_MESSAGES } from '../../constants/notification-messages';

@Component({
  selector: 'app-reassign-dialog',
  templateUrl: './reassign-dailog.component.html',
  styleUrls: ['./reassign-dailog.component.scss'],
  standalone: false,
})
export class ReassignDailogComponent
  extends AbstractComponent
  implements OnInit {
  @ViewChild('staff', { static: false }) staffSearch: StaffSearchComponent;
  public searchIcon: SVGIcon = searchIcon;
  // TODO: Right now we are not changing name of this dialog as we need to change in the entire application
  @Output() closeDialog: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() studentSk: string;
  @Input() nycId: string;
  @Input() isReAssign: boolean = false;
  // List of assignees for case reassignment
  assigneeList: StudentDetails[];
  caseAssign: StudentDetails[];
  public toggleText: string = 'Show';
  public showCaseAssign: boolean = false;
  public popupAligns: Align = { horizontal: 'center', vertical: 'top' };
  form: FormGroup;
  selectedStudentDetails: StudentDetails;
  loadSpinner: boolean;
  selectedSearch: boolean;
  readonly navigationDelayMs: number = 100;

  constructor(
    private fb: FormBuilder,
    private dashboardService: DashboardService,
    private notificationService: NotificationService
  ) {
    super();
    this.form = this.fb.group({
      reassign: [''],
    });
  }

  ngOnInit(): void {
    this.caseAssintogglePopup();
    this.setupFormValueChanges();
  }

  staffSelected(): void {
    this.selectedSearch = true;
  }

  resetSearch(staff: boolean): void {
    if (staff) {
      this.selectedSearch = false;
    }
  }

  onCloseDialog(): void {
    this.closeDialog.emit(false);
  }

  caseAssintogglePopup(): void {
    this.caseAssign = this.assigneeList;
    this.showCaseAssign = !this.showCaseAssign;
    this.toggleText = this.showCaseAssign ? 'Hide' : 'Show';
  }

  public onValueChange(value: string): void {
    if (value) {
      const searchTerms: string[] = value.toLowerCase().split(' ');

      this.caseAssign = this.assigneeList.filter((item: StudentDetails) => {
        const fullName: string = `${item.firstName.toLowerCase()} ${item.lastName.toLowerCase()}`;
        return searchTerms.every((term: string) => fullName.includes(term));
      });
    } else {
      this.caseAssign = this.assigneeList;
    }
  }

  assignCase(selectedStudent: StudentDetails): void {
    this.form
      .get('reassign')
      .setValue(selectedStudent?.firstName + ' ' + selectedStudent?.lastName);
    this.selectedStudentDetails = selectedStudent;
  }

  setupFormValueChanges(): void {
    this.form.get('reassign').valueChanges.subscribe((value: boolean) => {
      if (!value) {
        this.selectedStudentDetails = null;
      }
    });
  }

  submit(): void {
    this.loadSpinner = true;
    const caseAssignData: SubmitCaseAssignModel = new SubmitCaseAssignModel({
      studentSk: this.studentSk,
      personInfo: this.selectedStudentDetails as any,
      searchStudentDetails: this.staffSearch.selectedStaff,
    });
    this.dashboardService.SubmitCaseAssignment(caseAssignData).subscribe({
      next: (res: ApiResponse<CaseAssignment>) => {
        if (res.value.studentSk) {
          this.notificationService.show({
            content: NOTIFICATION_MESSAGES.submitSuccess,
            cssClass: 'notification-success',
            hideAfter: dialogTimer,
            position: { horizontal: 'center', vertical: 'top' },
            animation: { type: 'slide', duration: dialogAnimationDuration },
            type: { style: 'success', icon: true },
          });
          //Refresh the dashboard grid only after a successful/ complete submission.
          setTimeout(() => {
            this.dashboardService.getReloadDashboardGrid(true);
          }, this.navigationDelayMs);
          this.loadSpinner = false;
        }
        this.closeDialog.emit(true);
      },
      error: () => {
        this.loadSpinner = false;
      },
    });
  }

  override afterOnDestroy(): void {
    // throw new Error('Method not implemented.');
  }
}
